import Cookies from 'universal-cookie';
import { HYDRATE_CLIENT_STATE } from './client';
import myBidsFilterOptions from '../../enums/myBidsFilterOptions';
import { REHYDRATE } from 'redux-persist/constants';

const cookie = new Cookies();

const MAX_VIEW_COUNT_FOR_SEARCH = 120;
const UNSUPPORT_SEARCH_VIEW_COUNT = 'all';

/* Action Types */
export const CHANGE_PAGINATION_SORT_ORDER = 'la/ui/pagination/sortOrder';
export const CHANGE_PAGINATION_PAGE_SIZE = 'la/ui/pagination/pageSize';
export const CHANGE_PAGINATION_FILTER = 'CHANGE_PAGINATION_FILTER';

// reducer
const DEFAULT_LOCAL_STORAGE_STATE = {
    sort: {},
};
const DEFAULT_COOKIE_STATE = {
    pageSize: 24,
};

export function paginationLocalStorageReducer(state = DEFAULT_LOCAL_STORAGE_STATE, action = {}) {
    switch (action.type) {
        case REHYDRATE:
            if (
                Object.prototype.hasOwnProperty.call(action.payload, 'persist') &&
                Object.prototype.hasOwnProperty.call(action.payload.persist, 'pagination')
            ) {
                const incoming = action.payload.persist.pagination;
                return { ...state, ...incoming };
            }
            return state;
        case CHANGE_PAGINATION_SORT_ORDER:
            return {
                ...state,
                sort: { ...state.sort, [action.payload.type]: action.payload.sortOrder },
            };
        default:
            return state;
    }
}

export function paginationCookiesReducer(state = DEFAULT_COOKIE_STATE, action = {}) {
    switch (action.type) {
        case CHANGE_PAGINATION_PAGE_SIZE:
            return {
                ...state,
                pageSize: action.payload,
            };
        case HYDRATE_CLIENT_STATE:
            return {
                ...state,
                pageSize: action.payload.pageSize,
            };
        case CHANGE_PAGINATION_FILTER:
            return {
                ...state,
                filter: action.payload.filter,
            };
        default:
            return state;
    }
}

/* SELECTORS */
// Because this is global it will not be able to return a default.
export function getPaginationSortOrder(state, type) {
    return state.persist.pagination.sort[type] || '';
}

export function getPaginationPageSize(state) {
    return state.pagination.pageSize || 24;
}

export function getPaginationFilter(state) {
    return state.pagination.filter || myBidsFilterOptions.WON;
}

export const getSearchPageSize = state => {
    const pageSize = getPaginationPageSize(state);
    return pageSize === UNSUPPORT_SEARCH_VIEW_COUNT ? Number(MAX_VIEW_COUNT_FOR_SEARCH) : Number(pageSize);
};

/* ACTION CREATORS */
export const changePaginationSortOrder = (type, sortOrder) => ({
    payload: { sortOrder, type },
    type: CHANGE_PAGINATION_SORT_ORDER,
});

export const changePaginationFilter = filter => ({
    payload: { filter },
    type: CHANGE_PAGINATION_FILTER,
});

export const changePaginationPageSize = pageSize => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 60);
    cookie.set('pagination-page-size', pageSize, {
        domain: '.liveauctioneers.com',
        expires,
        path: '/',
    });
    return {
        payload: pageSize !== 'all' ? Number(pageSize) : pageSize,
        type: CHANGE_PAGINATION_PAGE_SIZE,
    };
};
